import React from 'react';
import dataAids from '../../../../constants/dataAids';
import { UX2 } from '@wsb/guac-widget-core';
import PropTypes from 'prop-types';
import { getProductLabel } from '../../utils/ProductUtils';

const ProductLabels = ({ product, translate }) => {
  const { Block, Details } = UX2.Element;

  const productLabel = getProductLabel(product, translate);
  const hasAllLabels = product.ship_free && product.free_return && product.limited_edition;
  const hasNoLabel = !product.ship_free && !product.free_return && !product.limited_edition;

  const dividerStyles = {
    ':not(:last-child)': {
      'marginRight': 'small',
      'paddingRight': 'small',
      'borderRightStyle': 'solid',
      'borderRightWidth': '1px',
      'borderColor': 'ultraLowContrast',
      '@xs-only': hasAllLabels
        ? {
          marginBottom: 'xsmall',
          marginRight: '0',
          paddingRight: '0',
          borderRightWidth: '0'
        }
        : null
    }
  };

  const styles = {
    container: {
      'display': 'flex',
      'paddingBottom': 'small',
      '@xs-only': hasAllLabels
        ? {
          flexDirection: 'column'
        }
        : {
          justifyContent: 'center'
        }
    },
    label: {
      textTransform: 'uppercase',
      textAlign: 'center',
      lineHeight: '1',
      ...dividerStyles
    }
  };

  if (hasNoLabel) return null;

  return (
    <Block style={ styles.container }>
      { (product.ship_free || product.free_return) && (
        <Details.Minor
          data-aid={ productLabel.labelDataAid }
          children={ productLabel.labelText }
          hidden={ !productLabel.labelText }
          style={ styles.label }
        />
      ) }

      { product.limited_edition && (
        <Details.Minor
          data-aid={ dataAids.PRODUCT_LIMITED_EDITION_RENDERED }
          children={ translate('products.limited_edition') }
          hidden={ !product.limited_edition }
          style={ styles.label }
        />
      ) }
    </Block>
  );
};

ProductLabels.propTypes = {
  product: PropTypes.object,
  translate: PropTypes.func
};

export default ProductLabels;
